module.exports = "/_next/static/images/e4f247d07ff3e273e705e57756a61681-pj-woman-working@3x.jpg";